import type { ColourFamily, StageShade } from '@crm/contracts';

/** A stage's dot, by family and shade — literal classes so Tailwind ships them (RELAY-948). */
export const SHADE_DOT: Record<ColourFamily, Record<StageShade, string>> = {
  violet: {
    '200': 'bg-violet-200',
    '300': 'bg-violet-300',
    '400': 'bg-violet-400',
    '500': 'bg-violet-500',
    '600': 'bg-violet-600',
    '700': 'bg-violet-700',
  },
  emerald: {
    '200': 'bg-emerald-200',
    '300': 'bg-emerald-300',
    '400': 'bg-emerald-400',
    '500': 'bg-emerald-500',
    '600': 'bg-emerald-600',
    '700': 'bg-emerald-700',
  },
  sky: {
    '200': 'bg-sky-200',
    '300': 'bg-sky-300',
    '400': 'bg-sky-400',
    '500': 'bg-sky-500',
    '600': 'bg-sky-600',
    '700': 'bg-sky-700',
  },
  rose: {
    '200': 'bg-rose-200',
    '300': 'bg-rose-300',
    '400': 'bg-rose-400',
    '500': 'bg-rose-500',
    '600': 'bg-rose-600',
    '700': 'bg-rose-700',
  },
  amber: {
    '200': 'bg-amber-200',
    '300': 'bg-amber-300',
    '400': 'bg-amber-400',
    '500': 'bg-amber-500',
    '600': 'bg-amber-600',
    '700': 'bg-amber-700',
  },
};
